import { getRequiredValidation, modifyRequiredValidation } from "@/components/forms/reusables/validationHelpers";
import { CommonProps } from "@/components/forms/types";
import store from "@/store";
import { computed, ref, Ref } from "vue";

export const useValidation = ({
    validation,
    name,
    moduleName,
    subModuleName,
}: {
    name: string;
    validation?: Ref<CommonProps["validation"] | undefined> | CommonProps["validation"];
    moduleName?: string;
    subModuleName?: string;
}) => {
    const overrideRequired = ref<boolean | null>(null);
    const shouldBeRequired = computed(() =>
        store.getters["config/shouldBeRequiredByName"]({
            name,
            moduleName,
            subModuleName,
            defaultRequired: getRequiredValidation({
                validation:
                    typeof validation === "object" ? (validation as Ref<CommonProps["validation"]>).value : validation,
            }),
        })
    );
    const modifiedValidation = computed(() => {
        const required =
            typeof overrideRequired?.value === "boolean" ? overrideRequired.value : shouldBeRequired?.value;

        return modifyRequiredValidation({
            validation:
                typeof validation === "object" ? (validation as Ref<CommonProps["validation"]>).value : validation,
            shouldBeRequired: required,
        });
    });

    const setOverrideRequired = ({ value }: { value: boolean | null }) => {
        overrideRequired.value = value;
    };

    return {
        modifiedValidation,
        expose: {
            setOverrideRequired,
        },
    };
};
